import numeral from 'numeral'

// see docs at http://numeraljs.com/

export const ordinal = (number) => {
  const lastDigit = number.toString().slice(-1)
  switch (lastDigit) {
    case '1':
      return 'st'
    case '2':
      return 'nd'
    case '3':
      return 'rd'
    default:
      return 'th'
  }
}

numeral.register('locale', 'en-gb', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal,
  currency: {
    symbol: '£'
  }
})

// switch between locales
numeral.locale('en-gb')

export const formatCurrency = (number, units = true) => {
  const format = `${units ? '$' : ''}0,0.00`
  return numeral(number).format(format)
}

export const formatCurrencyWhole = (number, units) => {
  const format = `${units ? '$' : ''}0,0`
  return numeral(number).format(format)
}

export const formatCurrencyRounded = (number, units) => {
  const format = `${units ? '$' : ''}0,0[.]0a`
  return numeral(number).format(format)
}

export const formatThousands = (number) => {
  const format = `0,0[.][00000000]`
  return numeral(number).format(format)
}

export const formatPhoneNumber = (number) => {
  if (!number) return number
  let phoneNumber = String(number).replace(/ /g, '').replace(/-/g, '')

  if (phoneNumber.length < 6) return phoneNumber

  if (phoneNumber.includes('+44') && phoneNumber.length > 11) {
    phoneNumber = phoneNumber.replace('+44', '+44 ')
    phoneNumber = phoneNumber.substring(0, 8) + ' ' + phoneNumber.substring(8)
    return phoneNumber
  }

  // add a space after the first 5 digits
  phoneNumber = phoneNumber.substring(0, 5) + ' ' + phoneNumber.substring(5)
  return phoneNumber
}
export const roundNumber = (value, decimalPlaces) => {
  if (decimalPlaces === null || decimalPlaces === undefined) return Number(value)
  if (value === null || value === undefined) return value
  return Number(Number(value).toFixed(decimalPlaces))
}

export const formatBytes = (kb, decimalPlaces = 1) => {
  const bytes = kb * 1024 // Convert KB to bytes
  if (bytes < 1) return '< 1 Byte'
  const k = 1024
  let dm = decimalPlaces ?? 1
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  const units = sizes[i]

  if (units === 'Bytes' || units === 'KB') {
    dm = 0
  }

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + units
}
